import React from 'react';

export default function About() {
  return (
    <section id="about" className="py-24 px-6 max-w-5xl mx-auto">
      <div className="grid md:grid-cols-2 gap-16 items-center">

        {/* Text */}
        <div>
          <p className="text-accent font-body text-sm tracking-[0.2em] uppercase mb-4">About</p>
          <h2 className="font-display text-4xl text-ink mb-6 leading-snug">
            Full-Stack Developer.
          </h2>
          <p className="font-body text-muted leading-relaxed mb-4">
            I design and build backend systems and microservices with a focus on
            simplicity — no over-engineering, no unnecessary dependencies.
          </p>
          <p className="font-body text-muted leading-relaxed mb-4">
            Currently running a production stack of Spring Boot, FastAPI, and .NET
            microservices with AI inference on a Raspberry Pi 4 — because constraints
            breed better architecture.
          </p>
          <p className="font-body text-muted leading-relaxed">
            Based in the Netherlands. Available for freelance and collaboration.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-6">
          {[
            { number: "3+", label: "Microservices in production" },
            { number: "Pi 4", label: "Runs the whole stack" },
            { number: "AI", label: "Local LLM inference" },
            { number: "NL", label: "Based in Netherlands" },
          ].map(({ number, label }) => (
            <div key={label} className="border border-accent/30 p-6">
              <p className="font-display text-4xl text-accent mb-2">{number}</p>
              <p className="font-body text-sm text-muted leading-snug">{label}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
